import { createMediaQuery } from 'app/functions/grid';

export const breakpointMatches = (...sizes: string[]) =>
  window.matchMedia
    ? window.matchMedia(createMediaQuery(...sizes))
    : ({ matches: false } as MediaQueryList);
